import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Returns a function to use query strings from URLs.
 *
 * ## Example
 * ```javascript
 * const query = useQuery();
 * // `productId` will be set to value of "id" in query string
 * const productId = query.get("id");
 * ```
 */
export const useQuery = () => {
  const { search } = useLocation()

  return useMemo(() => new URLSearchParams(search), [search])
}
